import SgmMonitor from '@/api/lib/monitor'
import { commonAddLog } from '@/api/biz/shipment/pack/paperlessPackageTag'
import { userInfo } from '@/global';

export const SgmPrintMonitor = (code, time, param = {}) => {
  try {
    SgmMonitor.customMonitor({
      code: `SGM_custom_consumingTime_${code}`,
      msg: {
        desc: `${printMonitorCodeEnum[code]} : ${time}`,
        params: {time, ...param, ...userInfo}
      }
    })
  } catch (error) {
    console.log(error)
  }
  try {
    cutoutLogAndReporting(code, code, {time, ...param, ...userInfo})
  } catch (error) {
    console.log(error)
  }
}

export const printMonitorCodeEnum = {
  browserPrint_PNG_print: 'PNG面单convertBase64转换浏览器打印PNG耗时',
  browserPrint_PNG_convertBase64: 'PNG面单convertBase64转换耗时',
  browserPrint_PNG_convertBase64AndPrint: 'PNG面单convertBase64转换+打印总耗时',
  browserPrint_PDF_print: 'PDF面单convertBase64转换浏览器打印PNG耗时',
  browserPrint_PDF_convertBase64: 'PDF面单convertBase64转换耗时',
  browserPrint_PDF_convertBase64AndPrint: 'PDF面单convertBase64转换+打印总耗时',
  browserPrint_HTML_print: 'HTML面单打印耗时',
  browserPrint_ZPL_print: 'ZPL面单打印耗时',
  browserPrint_base64AndUrl_print: 'base64串或url链接打印耗时',
  cloudPrint_PDF_print: 'PDF面单convertBase64转换云打印耗时',
  cloudPrint_PDF_convertBase64AndPrint: 'PDF面单convertBase64转换+云打印总耗时',
  call3plAPi_url_3pl: '调用3pl(url_3pl)接口耗时',
  call3plAPi_url_3pl_async_label: '调用3pl(url_3pl_async_label)异步面单接口耗时',
  call3plAPi_url_printPlatform: '调用3pl(url_printPlatform)接口耗时',
  call3plAPi_url_3pl_platForm_new: '调用3pl(url_3pl_platForm_new)接口耗时',
  cloudPrint: '云打印耗时',
  cloudPrint_queryCloudPrintConfigList: '云打印-查询库内云打印模板耗时',
  cloudPrint_getCloudPrintTemplate: '云打印-获取云打印模板版本',
  cloudPrint_setCloudPrintTemplate: '云打印-设置云打印模板版本',
  call3plAPi_url_3pl_platForm_dangerous_package_makePrintParams: '调用3pl(url_3pl_platForm_dangerous_package)打印adr组装参数耗时',
  call3plAPi_url_3pl_platForm_dangerous_package: '调用3pl(url_3pl_platForm_dangerous_package)打印adr接口请求耗时',
  call3plAPi_url_3pl_platForm_dangerous_package_executePrint: '调用3pl(url_3pl_platForm_dangerous_package)打印adr打印耗时',
  call3plAPi_url_3pl_platForm_dangerous_one_package_makePrintParams: '调用3pl(url_3pl_platForm_dangerous_package)打印adr组装参数耗时',
  call3plAPi_url_3pl_platForm_dangerous_one_package: '调用3pl(url_3pl_platForm_dangerous_package)打印adr接口请求耗时',
  call3plAPi_url_3pl_platForm_dangerous_one_package_executePrint: '调用3pl(url_3pl_platForm_dangerous_package)打印adr打印耗时',
  openReportFullScreen: '打开全屏',
  exitReportFullScreen: '退出全屏',
  adr_one_package_createPackageParamInfo_obCheckMR_log: '单包裹adr打印obCheckMR',
  adr_one_package_createPackageParamInfo_printParam_log: '单包裹adr打印printParam',
  adr_one_package_createPackageParamInfo_packageParamInfo_log: '单包裹adr打印组装后参数packageParamInfo',
  adr_packages_createPackageParamInfo_packageNo_log: '多包裹adr打印包裹号packageNo',
  adr_packages_createPackageParamInfo_printParam_log: '多包裹adr打印printParam',
  adr_packages_createPackageParamInfo_obCheckMR_log: '多包裹adr打印obCheckMR',
  adr_packages_createPackageParamInfo_call3plResultList_log: '多包裹adr打印请求3pl返回数据call3plResultList',
  adr_packages_createPackageParamInfo_packageParamInfo_log: '多包裹adr打印组装后参数packageParamInfo',
  call3plAPi_url_3pl_platForm_new_request: '调用3pl(url_printPlatform)请求入参',
  call3plAPi_url_3pl_request: '调用3pl(url_3pl)请求入参',
  call3plAPi_url_3pl_async_label_request: '调用3pl(url_3pl_async_label)请求入参',
  package_qty_dialog_visible: '非包裹明细采集弹窗',
  close_container: '关闭容器请求入参',
  get_check_data_by_task_pageNoAndOrderNo: '请求拿到更新数据',
  update_check_data_by_task_pageNoAndOrderNo: '更新复核明细数据',
  get_check_data: '更新复核数据完成',
  submit_check_data:'提交复核数据拿到请求结果以及参数',
  error_get_check_data:'更新复核数据异常',
  sgmLogMonitor_error: 'sgm异常上报',
  outbound_numEnter_log: '大小件复核数量框提交',
  outbound_uniqueCodeEnters_log: '大小件复核唯一码框提交',
  outbound_batchOperation_log: '大小件复核订单匹配提交',
  outbound_submitCheckData_log: '大小件复核提交复核数据',
  outbound_submitCheckData_error_log: '大小件复核提交复核数据异常',
  outbound_fullPackage_noFullParcelCapacity_log: '大小件复核无满包裹能力',
  outbound_fullPackage_consumbles_log: '大小件复核耗材扫描',
  outbound_fullPackage_trigger_log: '大小件复核触发满包裹',
  outbound_fullPackage_trigger_error_log: '大小件复核触发满包裹异常',
  outbound_fullPackage_print_log: '大小件复核触发满包裹后打单',
  outbound_fullPackage_notPrint_log: '大小件复核触发满包裹后不打单',
  outbound_fullPackage_finish_log: '大小件复核满包裹完成',
  outbound_fullPackage_log: '大小件复核执行满包裹',
}

const cutoutLogAndReporting = (bizName, bizKey, logInfo, time = 0, maxLength = 3000, cutoutLength = 80) => {
  try {
    let logStrInfo = JSON.stringify(logInfo)
    if(logStrInfo && logStrInfo.length > maxLength){
      logStrInfo = logStrInfo.substring(0, cutoutLength)
    }
    commonAddLog(bizName, bizKey, `上报结果：${logStrInfo}, 耗时：${time}`)
  } catch (error) {
    console.log(error)
  }
}


